module.exports = __webpack_public_path__ + "static/media/light_logo.7decc361.svg";